export default {
  twitter: {
    site: "@deepcityio",
    handle: "@Deepcity7",
    cardType: "summary_large_image",
  },
  openGraph: {
    title: `Deepcity | Home`,
    description: `Deepcity is a decentralized marketplace for digital assets. Where creators and collectors can interact and trade digital assets.`,
    site_name: "Deepcity",
    url: "https://www.deepcity.io",
    images: [
      {
        url: "https://deepcity-dev.s3.ap-south-1.amazonaws.com/thumbnail_DC_2b78de6397.png?width=200&height=200?imwidth=200",
        width: 300,
        height: 300,
        alt: "Deepcity logo",
        type: "image/png",
      },
    ],
  },
};
